// w16.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W16 = () => {
  return <WW config={pageConfigs.w16} />;
};

export default W16;
